import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  title: {
    boxSizing: 'border-box',
    background: theme?.palette?.header?.main,
    overflow: 'hidden',
    height: '46px',
    color: 'black',
  },
  logoWrapper: {
    width: 'max-content',
    marginRight: 'auto',
    marginLeft: '16px',
  },
  timerWrapper: {
    position: 'absolute',
  },
  secondsTimer: {
    width: 'max-content',
  },
  quizzDetailsWrapper: {
    marginLeft: 'auto',
    height: '100%',
    width: 'max-content',
  },
  cameraIcon: {
    padding: 0,
    height: '24px',
    width: '24px',
  },
  videoIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0rem 1rem',
    borderLeft: `solid 1px ${theme?.palette?.headerDividerLines?.main}`,
  },
  instructionsIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0rem 1rem',
    borderLeft: `solid 1px ${theme?.palette?.headerDividerLines?.main}`,
    borderRight: `solid 1px ${theme?.palette?.headerDividerLines?.main}`,
  },
  instructionsWrapper: {
    padding: 0,
  },
  closeIconWrapper: {
    width: '100%',
  },
  instructionsHeader: {
    fontSize: '22px',
    fontWeight: 700,
    wordBreak: 'break-word',
    color: '#202020',
    paddingLeft: '40px',
    paddingBottom: '20px',
  },
  instructionsPointsWrapper: { padding: '0px 40px 35px 40px' },
  instructionIcon: {
    color: theme?.palette?.borders?.main,
  },
  instructionsPoints: {
    fontSize: '14px',
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
  },
  instructionsIcon: {
    padding: 0,
    height: '24px',
    width: '24px',
  },
  answeredWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0rem 1rem',
  },
  answeredText: {
    color: theme?.palette?.lightTextColor?.main,
  },
  submitButtonWrapper: {
    marginRight: '5px',
    padding: '5px 0',
  },
  submitButton: {
    background: theme?.palette?.secondaryButton?.main,
    color: theme?.palette?.secondaryButton?.contrastText,
    fontWeight: theme?.palette?.secondaryButton?.fontWeight,
    border: `solid 1px ${theme?.palette?.primarySelection?.main}`,
    '&:hover': {
      background: theme?.palette?.secondaryButton?.hover,
    },
  },
  emailId: {
    color: 'white',
    marginLeft: '0.75rem',
    fontSize: '0.75rem',
  },
}))
export { useStyles }
